import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HomePage from './components/home/HomePage.vue';
import OperatorL from './components/operator/Operator-l.vue';
import TecData from './components/technical-data/Tec-Data.vue';
import ModelsL from './components/models/Models-l.vue';
import PamphletL from './components/pamphlet-L/Pamphlet-L.vue';
import ContactL from './components/Contact/Contact-L.vue';
import MapL from './components/map/Map-l.vue';
import FooterL from './components/footer/Footer-l.vue';
import BackToTop from './components/BackToTop.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HomePage),
    _createVNode(OperatorL),
    _createVNode(TecData),
    _createVNode(ModelsL),
    _createVNode(PamphletL),
    _createVNode(ContactL),
    _createVNode(MapL),
    _createVNode(FooterL),
    _createVNode(BackToTop)
  ], 64))
}
}

})